<script>
import GuiaStepSvg from "../dashboards/guia-step-svg.vue";

export default {
  components: {
    GuiaStepSvg
  },
  
  props: {
    certificados: Array
  },

  data() {
    return {
    };
  },

  methods: {
    handleQueroCertificadoDigital() {
      window.open('https://www.notabrasil.com.br/certificado-digital/#plans', '_blank');
    },
  },

  computed: {
    mensagem() {
      if (!this.certificados || this.certificados.length == 0) {
        return 1
      } else if (this.certificados[0].validade <= 0) {
        return 2 //vencido
      } else if (this.certificados[0].validade <= 15) {
        return 3 //vencimento proximo
      } else 
        return 0
    }
  },

  created() {

  },

  mounted() {

  }

};
</script>

<template>
  <div
    v-if="mensagem && mensagem != 0"
    class="nb-cert-alert-banner shadow-sm"
  >
    <!-- BLOCO DA ILUSTRAÇÃO SVG (GUIA PRIMEIROS PASSOS) -->
    <div class="nb-cert-alert-img-box shadow-sm">
      <guia-step-svg step="guianfe_certificado" label="CERTIFICADO A1" :completed="mensagem == 0"></guia-step-svg>
    </div>

    <!-- BLOCO DO TEXTO / MENSAGEM -->
    <div class="nb-cert-alert-content">
      <h2
        class="nb-cert-alert-title"
        v-if="mensagem == 3"
      >
        Seu certificado vencerá em {{ certificados[0].dtval | formatData }}
      </h2>
      <h2
        class="nb-cert-alert-title"
        v-if="mensagem == 2"
      >
        Seu certificado digital está
        <span class="nb-cert-tag-white">Vencido!</span>
      </h2>
      <h2
        class="nb-cert-alert-title"
        v-if="(mensagem == 1) || (mensagem == 2)"
      >
        <span class="nb-cert-tag-white">Adquira já</span>
        seu certificado digital A1
        <span class="d-none d-sm-inline"><br /></span>
        para emitir sua NF-e sem complicações
      </h2>

      <p class="nb-cert-alert-desc mb-0">
        Com o Nota Brasil você pode adquirir o certificado digital da sua empresa até no mesmo dia que solicitar.
      </p>
    </div>

    <!-- BLOCO DE PREÇO E CTA -->
    <div class="nb-cert-alert-cta-box shadow-sm">
      <span class="badge badge-success nb-cert-badge-offer">melhor preço do mercado</span>
      <div class="nb-cert-price-wrap">
        <span class="nb-cert-model-text">Certificado Digital A1</span>
        <div class="nb-cert-price-val">
          <span class="nb-cert-currency">R$</span>
          <span class="nb-cert-amount">148,00</span>
        </div>
      </div>
      <button
        type="button"
        class="btn nb-cert-btn-buy"
        @click="handleQueroCertificadoDigital"
      >
        <i class="fa fa-shopping-cart mr-1"></i> Quero o certificado
      </button>
    </div>
  </div>
</template>

<style scoped>
.nb-cert-alert-banner {
  background-color: #eccf34;
  padding: 16px;
  border-radius: 12px;
  margin: 14px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 992px) {
  .nb-cert-alert-banner {
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 20px;
    gap: 20px;
    border-radius: 0 12px 0 12px;
  }
}

/* Ilustração SVG */
.nb-cert-alert-img-box {
  background-color: #ffffff;
  padding: 8px 12px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 160px;
  box-sizing: border-box;
}

@media (min-width: 992px) {
  .nb-cert-alert-img-box {
    width: 180px;
    padding: 12px;
    border-radius: 0 10px 0 10px;
  }
}

/* Conteúdo de Texto */
.nb-cert-alert-content {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

@media (max-width: 991px) {
  .nb-cert-alert-content {
    text-align: center;
  }
}

.nb-cert-alert-title {
  color: #211c1e;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 10px;
}

@media (min-width: 576px) {
  .nb-cert-alert-title {
    font-size: 20px;
  }
}

@media (min-width: 992px) {
  .nb-cert-alert-title {
    font-size: 24px;
    line-height: 1.3;
  }
}

.nb-cert-tag-white {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 2px 8px;
  display: inline-block;
  margin-right: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.nb-cert-alert-desc {
  color: #211c1e;
  font-size: 13.5px;
  line-height: 1.5;
  opacity: 0.92;
}

/* Card Preço & Botão */
.nb-cert-alert-cta-box {
  background-color: #ffffff;
  padding: 16px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
}

@media (min-width: 992px) {
  .nb-cert-alert-cta-box {
    width: 230px;
    max-width: 30%;
    padding: 20px 14px;
    border-radius: 0 10px 0 10px;
  }
}

.nb-cert-badge-offer {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 4px 8px;
}

.nb-cert-price-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.nb-cert-model-text {
  font-size: 14.5px;
  font-weight: 600;
  color: #334155;
}

.nb-cert-price-val {
  color: #0b1c30;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 3px;
}

.nb-cert-currency {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.nb-cert-amount {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
}

.nb-cert-btn-buy {
  color: #ffffff !important;
  background-color: #004e94;
  border: 1px solid #004e94;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 600;
  border-radius: 6px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  transition: background-color 0.15s ease, transform 0.1s ease;
  cursor: pointer;
}

.nb-cert-btn-buy:hover {
  background-color: #00386b;
  border-color: #00386b;
  transform: translateY(-1px);
}

.nb-cert-btn-buy:active {
  transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/components/alert-cert.vue